import React, { useState } from "react";
import * as R from "ramda";
import CSSModules from "react-css-modules";
import styles from "./styles.scss";

const decorate = CSSModules(styles);

const PopoverMenu = ({ options, Trigger, menuStyle }) => {
  const [show, setShow] = useState(false);
  return (
    <div styleName="popover" tabindex="0" onBlur={() => setShow(false)}>
      <div styleName="triggerButton" onClick={() => setShow(!show)}>
        {Trigger}
      </div>
      {show && (
        <div styleName="menu" style={menuStyle}>
          {R.map(
            ({ callback, label, Icon }) => (
              <div
                styleName="menuItem"
                onClick={() => {
                  setShow(false);
                  callback();
                }}
              >
                {Icon} {label}
              </div>
            ),
            options
          )}
        </div>
      )}
    </div>
  );
};

export default decorate(PopoverMenu);
